import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';
import { get, isString, map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getTranslatedValue } from 'src/common/utils/format-utils';
import { getRegionWarehouse } from '../../../thunks/region-thunks';

interface RegionsSelectProps extends SelectProps {
  className?: string;
  error?: boolean;
  helperText?: string;
  InputProps?: Record<string, any>;
  prompt?: boolean | string;
}

export const RegionsSelect: ComponentType<RegionsSelectProps> = ({
  label,
  error = false,
  helperText,
  InputProps,
  prompt,
  ...props
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { warehouse } = useSelector((state: RootStateOrAny) => state.region);
  const { i18n } = useTranslation();

  const value = String(get(props, 'value', ''));
  const options = map(warehouse.hits, (item, idx) => (
    <MenuItem value={get(item, 'id', '')} key={idx}>
      {getTranslatedValue(item.title, i18n.language)}
    </MenuItem>
  ));

  if (prompt) {
    options.unshift(
      <MenuItem value="" key="prompt">
        {isString(prompt) ? prompt : t('action.select', 'Выбрать')}
      </MenuItem>
    );
  }

  useEffect(() => {
    dispatch(getRegionWarehouse());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl error={error} fullWidth>
      <InputLabel sx={{ fontSize: 14 }}>{label}</InputLabel>
      <Select {...{ ...props, label, value }}>{options}</Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
